import { createListenerMiddleware } from '@reduxjs/toolkit';

import { FeatureService } from '../../services/features/FeatureService';
import { fetchPlayerConfigSyncAction } from '../apiActions/fetchPlayerConfigSyncAction';
import type { CoreRootState } from '../CoreStore';
import { autoplayActions } from '../slices/autoplay/slice';
import { toastActions } from '../slices/toast/slice';

export const autoplaySyncMiddleware = createListenerMiddleware<CoreRootState>();

autoplaySyncMiddleware.startListening({
  actionCreator: autoplayActions.finishAutoplayOnboarding,
  effect: (_, { dispatch, getState, unsubscribe }) => {
    const { JSESSIONID, metaServer: url } = getState().config?.session ?? {};

    if (!(JSESSIONID && url)) return;

    const timeStamp = Date.now();

    const body = { autoplay_onboarded: true };

    dispatch(
      fetchPlayerConfigSyncAction({
        JSESSIONID,
        ck: timeStamp.toString(),
        url: `${url}/api/ui/savePlayerConfigGeneric`,
        body,
      })
    );
    unsubscribe();
  },
});

autoplaySyncMiddleware.startListening({
  actionCreator: toastActions.createToast,
  effect: (action, { dispatch, getState }) => {
    const isAutoplayModalOpen = getState()?.autoplay.isOpen;
    const isAutoplayV2 = FeatureService.getFeature('isAutoplayV2') ?? false;

    if (action.payload === 'AUTOPLAY_COMPLETED' && !isAutoplayModalOpen && isAutoplayV2) {
      dispatch(autoplayActions.toggleOpen());
    }
  },
});
